"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputText = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.InputText = styled_components_1.default.input `
  padding: 5px;
`;
//# sourceMappingURL=input-text.js.map